import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { ICommitmentData } from '../models/apiCommitmentData'

export const getCrudCommitment = () => {
  return CrudStore.get(
    CrudStoreItemPartner360.Commitment,
    'CheckPartnerSign'
  ) as Crud<ICommitmentData>
}
